import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Globe, Info } from "lucide-react";

/**
 * Neutral notice shown inside the Android TWA in places that would
 * otherwise display purchase / subscription CTAs.
 *
 * IMPORTANT — Play Store compliance:
 *  - No words like "assinar", "comprar", "plano", "preço", "valor",
 *    "premium", "upgrade", "checkout", "R$".
 *  - Single generic CTA "Abrir site" without purchase context.
 */
const SITE_URL = "https://aipalpiteguru.mentepoderosa2030.com";

interface AndroidNeutralNoticeProps {
  className?: string;
}

const AndroidNeutralNotice: React.FC<AndroidNeutralNoticeProps> = ({ className }) => {
  const handleOpenSite = () => {
    try {
      window.open(SITE_URL, "_blank", "noopener");
    } catch {
      window.location.href = SITE_URL;
    }
  };

  return (
    <Card className={`max-w-xl mx-auto my-6 border-border ${className ?? ""}`}>
      <CardContent className="p-6 text-center space-y-4">
        <div className="flex justify-center">
          <div className="p-3 rounded-full bg-muted">
            <Info className="h-6 w-6 text-muted-foreground" />
          </div>
        </div>
        <p className="text-foreground text-sm sm:text-base leading-relaxed">
          Para ativar ou gerenciar sua conta, acesse nosso site oficial pelo navegador.
        </p>
        <Button
          onClick={handleOpenSite}
          variant="outline"
          className="mx-auto"
          aria-label="Abrir site oficial no navegador"
        >
          <Globe className="h-4 w-4 mr-2" />
          Abrir site
        </Button>
      </CardContent>
    </Card>
  );
};

export default AndroidNeutralNotice;
